var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.supported && _vm.isApplePayAvailable())?_c('button-apple',{attrs:{"on-click":_vm.instantCheckoutClick}}):(_vm.supported && !_vm.isApplePayAvailable())?_c('button-google',{attrs:{"on-click":_vm.instantCheckoutClick}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }